import { render, staticRenderFns } from "./EventApp.vue?vue&type=template&id=13007aba&"
import script from "./EventApp.vue?vue&type=script&lang=ts&"
export * from "./EventApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports